import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseServiceType } from "../_types/case-service-type";

@Injectable({
    providedIn: 'root',
})
export class CasesServicesTypesService extends Service<CaseServiceType> {
    public override type = 'caseServiceTypes';
    public override url = 'attendance/caseServiceTypes';
      
}
